import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";


class ProjeKategoriAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "ProjeKategori";
    super(baseUrl);
  }


  getProjeKategori( projeKategoriKodu?: number){
    return this.get("", { params: { projeKategoriKodu: projeKategoriKodu } })

  }

}


export default new ProjeKategoriAPI();
class ProjeKategoriRequest {
  public projeKategoriKodu?: number;

 
  constructor(projeKategoriKodu?: number) {
   
      this.projeKategoriKodu = projeKategoriKodu;

      
  }
}
export { ProjeKategoriRequest };